import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { Input, RegularModal } from '@/components_deprecated'
import { DetectBlur } from '@/containers/util-containers'
import type { VehicleExpirationTypeForm } from '@/modules/companies/CompanySettings'
import { Field, Form } from '@/modules/companies/CompanySettings'

interface VehicleExpirationTypePromptProps {
  initialData?: VehicleExpirationTypeForm
  existingNames: string[]

  onSubmit: PromptResolve<VehicleExpirationTypeForm | null>
}

export const VehicleExpirationTypePrompt: React.FC<
  VehicleExpirationTypePromptProps
> = ({ initialData, existingNames, onSubmit }) => {
  const translations = useTranslate({
    name: 'common.name',

    addExpirationType: 'settings.add-vehicle-expiration-type',
    editExpirationType: 'settings.edit-vehicle-expiration-type',

    create: 'common.create-alt',
    update: 'common.update',

    validation: {
      nameExists: 'settings.validation.vehicle-expiration-type-name-exists',
      required: 'common.required',
    },
  })

  const editing = typeof initialData !== 'undefined'

  function validateName(name: string) {
    const trimmed = name.trim()
    if (trimmed === initialData?.name) return null
    if (trimmed === '') return translations.validation.required
    if (existingNames.some(existing => existing === trimmed.toLowerCase())) {
      return translations.validation.nameExists
    }
    return null
  }

  const {
    formValues: form,
    formErrors: errors,
    formValid,
    formChangeHandler: handler,
    submitHandler: submit,
  } = useForm<VehicleExpirationTypeForm>({
    values: initialData ?? { name: '' },
    validators: {
      name: validateName,
    },
  })

  return (
    <DetectBlur active onClickOutside={() => onSubmit(null)}>
      <RegularModal
        title={
          editing
            ? translations.editExpirationType
            : translations.addExpirationType
        }
        submitText={editing ? translations.update : translations.create}
        submitDisabled={!formValid}
        width="400px"
        onCancel={() => onSubmit(null)}
        onSubmit={submit(form => onSubmit({ name: form.name.trim() }))}
      >
        <Form>
          <Field>
            <label>{translations.name}</label>
            <Input
              value={form.name}
              error={errors.name}
              autoFocus
              fullWidth
              onChange={handler('name')}
            />
          </Field>
        </Form>
      </RegularModal>
    </DetectBlur>
  )
}
